import React from 'react';
import { Routes, Route } from 'react-router-dom';
import BlogList from './BlogList';
import BlogEditor from './BlogEditor';
import BlogRules from './BlogRules';

const ContentManagement = () => {
  return (
    <div className="p-6">
      <Routes>
        <Route path="/" element={<BlogList />} />
        <Route path="/new" element={<BlogEditor />} />
        <Route path="/edit/:id" element={<BlogEditor />} />
        <Route path="/rules" element={<BlogRules />} />
      </Routes>
    </div>
  );
};

export default ContentManagement;